import { useEffect } from 'react'

const useOnMount = (callback) => {
  useEffect(callback, []) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useOnMount
